import { Link } from "@quintype/components";
import React, { useState } from "react";
import MenusChip from "../../../../../atoms/menus-chip";
import Search from "../../../../../atoms/other-icons/Search";
import SocialShareIcons from "../../../../../molecules/social-share";
import Navbar from "../nav-bar";

import {
  FOLLOW_US_TEXT,
  SEARCH_PLACEHOLDER
} from "../../../../../../constants";

import "./mobile-hamburger-page.m.css";
import MobileHamburgerMenuItem from "./MobileHamburgerMenuItem";

const MobileHamburgerPage = ({
  signinHandler,
  onAccountHandler,
  primaryMenus = [],
  secondaryMenus = [],
  currentPath
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [visibleIndex, setVisibleIndex] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const closingTimer = React.useRef(null);

  const toggleMenu = (index) => {
    if (closingTimer.current) clearTimeout(closingTimer.current);

    if (activeIndex === index) {
      // Closing
      setActiveIndex(null);
      setIsClosing(true);
      closingTimer.current = setTimeout(() => {
        setVisibleIndex(null);
        setIsClosing(false);
      }, 400);
    } else {
      // Opening new
      setActiveIndex(index);
      setVisibleIndex(index);
      setIsClosing(false);
    }
  };

  const toggleSearch = () =>
    setIsSearchOpen((prev) => !prev);

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter" && searchText.trim()) {
      window.location.href = `/search?q=${searchText}`;
    }
  };

  const allMenus = primaryMenus;


  return (
    <div styleName="wrapper">
      <Navbar
        signinHandler={signinHandler}
        onAccountHandler={onAccountHandler}
        isSearchOpen={isSearchOpen}
        toggleSearch={toggleSearch}
      />

      <div styleName="menus-wrapper">
        <MenusChip menus={secondaryMenus} />
      </div>

      {isSearchOpen && (
        <div styleName="search-wrapper">
          <div styleName="search-input-wrapper">
            <input
              type="text"
              placeholder={SEARCH_PLACEHOLDER}
              styleName="search-input"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={handleSearchKeyDown}
            />
            <Link
              href={`/search?q=${searchText}`}
              styleName="search-icon-btn"
              aria-label="Search"
            >
              <Search />
            </Link>
          </div>
        </div>
      )}

      <div styleName="menu-cards-wrapper">
        {allMenus.map((item, idx) => {
          const isPrimary = true;
          return (
            <MobileHamburgerMenuItem
              key={idx}
              item={item}
              index={idx}
              isActive={activeIndex === idx}
              isVisible={visibleIndex === idx}
              isClosingSubmenu={isClosing && visibleIndex === idx && activeIndex !== idx}
              toggleMenu={toggleMenu}
              currentPath={currentPath}
              allMenus={allMenus}
              currentIndex={idx}
              menuType={isPrimary ? 'primary' : 'secondary'}
              primaryMenuCount={primaryMenus.length}
            />
          );
        })}
      </div>

      <div styleName="menu-footer">
        {FOLLOW_US_TEXT}
        <SocialShareIcons />
      </div>
    </div>
  );
};

export default MobileHamburgerPage;
